import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function tabsAndMenusReducer(
  state = initialState.menus,
  action
) {
  switch (action.type) {
    case types.GET_TABS_AND_MENUS:
      return action.menus;
    default:
      return state;
  }
}
